// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"03c28bc1","650":"f208b468","730":"84339fb5","835":"ba541df3"}[chunkId] + ".chunk.js";
};